import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const RevertIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.42 11.96C6.42 15.04 8.9 17.6 12 17.6C15.08 17.6 17.58 15.04 17.58 11.96C17.58 8.86 15.08 6.28 12 6.28C10.02 6.28 8.48 7.32 7.52 8.9H10.9V10.38H4.54V4.04H6.02V7.84C7.28 5.82 9.42 4.48 12 4.48C16.1 4.48 19.46 7.88 19.46 11.96C19.46 16.04 16.1 19.4 12 19.4C7.9 19.4 4.54 16.04 4.54 11.96H6.42Z" />
    </SvgIcon>
  );
});
